import { render, staticRenderFns } from "./pinned_section.vue?vue&type=template&id=65fdb398&vue3"
import script from "./pinned_section.vue?vue&type=script&lang=js&vue3"
export * from "./pinned_section.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports